import React, { useState, useEffect } from 'react'
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';
import {getCsrfToken} from '../../commons/authenticityToken';

export const PatientCount = React.createContext(undefined);

const index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
  // ロード
  const [isLoading, setIsLoading] = useState<Boolean>(true);
  const [templates, setTemplates] = useState([]);

  // 初期ロード
  useEffect(() =>{
    axios.get(
      '/api/internal/templates/patient_view_templates', { params: { m_institution_id: props.m_institution.id }
    }).then(function (response) {
      setTemplates(response.data.m_templates);
      setIsLoading(false);
    }).catch(error => {
      setIsLoading(false);
      alert(error.response.data.message)
    });
  }, [])  

  // 先確認データ登録
  const submitInterview = (template_id) => {
    setIsLoading(true);
    axios.post(
      '/api/internal/interview/setup', {
        patients: [{ userNo: 1, name: "新患", isNewPatient: "true", patientId: "", templateId: template_id, isLineLinked: false}],
        m_institution_id: props.m_institution.id
    }).then(function (response) {
        const key = `/interview/index?interview_key=${response.data.interview_key}`;
        location.href = (key);
        setIsLoading(false);
    }).catch(error => {
        setIsLoading(false);
        alert(error.response.data.message);
      }); 
  }

  const convertNewLine = (str) =>{
    const messages = str ? str.split(/(\r\n|\n|\r)/g) : [];
    const convert_str = messages.map((v) =>{
      return (
        <React.Fragment>
          {v.match(/(\r\n|\n|\r)/g) ? <br/> : v}
        </React.Fragment>
      )
    })

    return convert_str
  }

  return(
    <>
     <LoadingOverlay active={isLoading} spinner text='Loading...'>
        <div className="row row-height-flex full margin-all-0 apple-system-font">
          <div className="panel panel-defalut col-md-12 col-sm-12 col-xs-12 padding-left-0 padding-right-0 border-none margin-all-0">
            <div className="panel-body bg-green height-100">
              <div className="panel panel-defalut col-md-12 col-sm-12 col-xs-12 height-100 bg-subscreen">
                <div className="panel-body">
                  <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                      <h3 className="question-title">{`${props.m_institution.institution_name}`}</h3> 
                    </div>
                  </div>
                  <hr className="border-top-5"/>
                  <div className="scroll comment-area">
                    <h3 className="question-title text-center">{convertNewLine(props.m_institution.interview_message)}</h3>
                  </div>
                  <br/>
                  <div className="scroll patient-template-area">
                    { templates.map((template) =>
                      <div className="row">
                        <div className="col-md-3 col-sm-3 d-xs-none" />
                        <div className="col-md-6 col-sm-6 col-xs-12">
                          <input key={"gender_" + template.id} type="button" className="radio-button" value={template.display_web_name} onClick={() => submitInterview(template.id)}/>
                        </div>
                        <div className="col-md-3 col-sm-3 d-xs-none" />
                        </div>
                    )}
                    </div> 
                  </div>
                </div>
            </div>
          </div>
        </div>
        </LoadingOverlay>
    </>
  )
}

export default index
